export default __webpack_public_path__ + "static/media/defaultAvatar.8d49e377.png";